import { AnalyticsEvents } from '../../constants/events'

export const startGTM = () => {
	window.dataLayer.push({
		[AnalyticsEvents.GTM_START]: new Date().getTime(),
		event: AnalyticsEvents.GTM_JS,
	})
}
